import { Box } from '@material-ui/core';
import { useMemo } from 'react';

import { ProgressBarAndTimeline } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/PaymentMethods/PaymentMethod/_shared/components/ConditionsAndProgress/ProgressBarAndTimeline/Progress/ProgressBarAndTimeline';
import { CreditLinePaymentMethodDetailEntity } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/PaymentMethods/PaymentMethod/Loan/CreditLine/_shared/entities/PaymentMethodDetail/CreditLinePaymentMethodDetailEntity';
import { Conditions } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/PaymentMethods/PaymentMethod/Loan/CreditLine/ConditionsAndProgress/Conditions/Conditions';
import { PaymentIntentFactory } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/PaymentMethods/PaymentMethod/Loan/Loan/PaymentIntent/PaymentIntentFactory';
import { CustomPaper } from '@/components/shared/components/CustomPaper';

interface ConditionsAndProgressProps {
  paymentMethodDetailEntity: CreditLinePaymentMethodDetailEntity;
  onOpenMerchantPos: () => void;
}

export const ConditionsAndProgress = ({ paymentMethodDetailEntity, onOpenMerchantPos }: ConditionsAndProgressProps) => {
  const shouldCreatePaymentIntent = useMemo(
    () => paymentMethodDetailEntity.shouldCreatePaymentIntent(),
    [paymentMethodDetailEntity],
  );

  return (
    <CustomPaper
      fill="paper"
      style={{
        minWidth: 0,
        minHeight: '220px',
        overflow: 'visible',
        position: 'relative',
        paddingBottom: 24,
      }}
    >
      <Box
        mb={shouldCreatePaymentIntent ? 2 : 0}
        style={{
          opacity: shouldCreatePaymentIntent ? '0.6' : '1',
          pointerEvents: shouldCreatePaymentIntent ? 'none' : 'auto',
        }}
      >
        <Box minHeight={94}>
          <Conditions paymentMethodDetailEntity={paymentMethodDetailEntity} />
        </Box>
        {!shouldCreatePaymentIntent && (
          <>
            <Box mt={3} />
            <ProgressBarAndTimeline paymentMethodDetailEntity={paymentMethodDetailEntity} />
          </>
        )}
      </Box>
      {shouldCreatePaymentIntent && (
        <PaymentIntentFactory
          paymentMethodDetailEntity={paymentMethodDetailEntity}
          onOpenMerchantPos={onOpenMerchantPos}
        />
      )}
    </CustomPaper>
  );
};
